/** BCP-47 language code, e.g. 'en', 'es', 'ru', 'ar', 'zh-Hans'. Dynamic — not an enum. */
export type LanguageCode = string;

export type LanguageDirection = 'LTR' | 'RTL';

/** Mirrors rn-portal's `language` table. Fetched from rn-portal, never hardcoded. */
export interface Language {
    code: LanguageCode;
    englishName: string;
    nativeName: string;
    direction: LanguageDirection;
    defaultEncoding: 'GSM7' | 'UCS2';
    isActive: boolean;
    /** Lower = more widely spoken; answers a system keyword two languages share. */
    priority: number;
    /** The language's system (universal) keywords, shown in the Add Language picker. */
    systemKeywords: { STOP: string[]; HELP: string[] };
}

export function deserializeLanguage(input: object): Language {
    return {
        code: input['code'],
        englishName: input['englishName'],
        nativeName: input['nativeName'],
        direction: input['direction'] === 'RTL' ? 'RTL' : 'LTR',
        defaultEncoding: input['defaultEncoding'] === 'UCS2' ? 'UCS2' : 'GSM7',
        isActive: input['isActive'] ?? true,
        priority: input['priority'] ?? Number.MAX_SAFE_INTEGER,
        systemKeywords: {
            STOP: input['systemKeywords']?.['STOP'] ?? [],
            HELP: input['systemKeywords']?.['HELP'] ?? [],
        },
    };
}

/** Unrecognized Response is hardcoded English-only — the one legitimate remaining hardcode. */
export const ENGLISH_LANGUAGE_CODE: LanguageCode = 'en';
